<template>
  <div class="users-list">
    <b-row class="admin-header">
      <b-col class="admin-header-col">Bienvenue Coralie !</b-col>
      <b-col class="admin-header-col"><b-button class="custom-button" v-b-modal.modalAddUser>Ajouter un sous-fifre</b-button></b-col>
    </b-row>
    <b-modal ref="modalAddUserRef" id="modalAddUser" title="Ajouter un sbire">
      <modalAddUser v-on:addNewUser="createUser"/>
      <div slot="modal-footer" class="w-100">
        <p>Et ainsi s'achève son existence paisible</p>
      </div>
    </b-modal>
    <b-table hover :items="users" :fields="fields" sort-by="lastname">
      <template slot="lastname" slot-scope="data">
        {{data.item.lastname}}
      </template>
      <template slot="firstname" slot-scope="data">
        {{data.item.firstname}}
      </template>
      <template slot="ffb" slot-scope="data">
        <b-button v-if="data.item.ffb !== 0" class="button-remove" size="sm" variant="danger" @click="takeFfb(data.item.id, data.item.ffb)">-1</b-button>
        {{data.item.ffb}}
        <b-button class="button-add" size="sm" variant="success" @click="addFfb(data.item.id, data.item.ffb)">+1</b-button>
      </template>
      <template slot="blame" slot-scope="data">
        <b-button v-if="data.item.blame !== 0" class="button-remove" size="sm" variant="danger" @click="takeBlame(data.item.id, data.item.blame)">-1</b-button>
        {{data.item.blame}}
        <b-button class="button-add" size="sm" variant="success" @click="addBlame(data.item.id, data.item.blame)">+1</b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from 'axios';
import store from 'store';
import ModalAddUser from './modals/addUser.vue';
import UpdateService from '../services/update-operations.js';
const updateService = new UpdateService();
import { isNil } from 'lodash';
export default {
  name: 'usersListAdmin',
  components: {
    ModalAddUser
  },
  data: () => ({
    users: [],
    fields: [
      {
        key: 'lastname',
        label: 'Nom',
        sortable: true
      },
      {
        key: 'firstname',
        label: 'Prenom',
        sortable: true
      },
      {
        key: 'ffb',
        label: 'Bons Fast Food disponible(s)',
        sortable: true
      },
      {
        key: 'blame',
        label: 'Avertissement(s)',
        sortable: true
      }
    ]
  }),
  beforeCreate() {
    if (isNil(store.get('token'))) {
      this.$router.push('/');
    }
  },
  mounted() {
    updateService.getUsers().then(res => (this.users = res));
  },
  methods: {
    addFfb(id, oldFfb) {
      updateService
        .addFfb(id, oldFfb, store.get('token').token)
        .then(() => updateService.getUsers().then(res => (this.users = res)));
    },
    takeFfb(id, oldFfb) {
      updateService
        .takeFfb(id, oldFfb, store.get('token').token)
        .then(() => updateService.getUsers().then(res => (this.users = res)));
    },
    addBlame(id, oldBlame) {
      updateService
        .addBlame(id, oldBlame, store.get('token').token)
        .then(() => updateService.getUsers().then(res => (this.users = res)));
    },
    takeBlame(id, oldBlame) {
      updateService
        .takeBlame(id, oldBlame, store.get('token').token)
        .then(() => updateService.getUsers().then(res => (this.users = res)));
    },
    createUser(user) {
      updateService
        .addUser(user, store.get('token').token)
        .then(() => updateService.getUsers().then(res => (this.users = res)));
      this.$refs.modalAddUserRef.hide();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.button-remove {
  margin-right: 10px;
}
.button-add {
  margin-left: 10px;
}
.logout-btn {
  margin: 1%;
}
.admin-header-col {
  margin: auto;
}
</style>
